module.exports = __webpack_public_path__ + "img/img_brand31.71b2b345.jpg";